import { WalletOutlined } from '@ant-design/icons';
import { history } from '@umijs/max';
import { createStyles } from 'antd-style';
import React, { useEffect, useState } from 'react';
import {
  fmtMoney,
  refreshWallet,
  subscribeWallet,
} from '@/services/cloud-billing';

const STEEL = '#1b4f8c';
const INK = '#0b1526';

const useStyles = createStyles(() => ({
  wrap: {
    display: 'inline-flex',
    alignItems: 'center',
    height: '100%',
    maxHeight: 56,
    paddingInline: 6,
    boxSizing: 'border-box',
  },
  pill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    height: 32,
    padding: '0 12px',
    margin: 0,
    borderRadius: 999,
    border: '1px solid #e4e8ef',
    background: 'linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%)',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: 12.5,
    lineHeight: '30px',
    color: 'rgba(11,21,38,0.65)',
    boxSizing: 'border-box',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    boxShadow: '0 1px 2px rgba(11, 21, 38, 0.04)',
    transition: 'border-color 0.18s, box-shadow 0.18s, background 0.18s',
    '&:hover': {
      borderColor: 'rgba(27, 79, 140, 0.4)',
      boxShadow: '0 2px 8px rgba(11, 21, 38, 0.06)',
      background: '#fff',
    },
  },
  icon: {
    fontSize: 14,
    color: STEEL,
    lineHeight: 1,
  },
  label: {
    color: 'rgba(11,21,38,0.45)',
    fontWeight: 500,
  },
  amount: {
    color: INK,
    fontWeight: 650,
    fontSize: 13,
    fontVariantNumeric: 'tabular-nums',
    letterSpacing: '-0.02em',
  },
  amountWarn: {
    color: '#b45309',
  },
  divider: {
    width: 1,
    height: 14,
    background: '#e4e8ef',
    marginInline: 2,
    flexShrink: 0,
  },
  recharge: {
    color: STEEL,
    fontWeight: 650,
    fontSize: 12.5,
  },
}));

const BalancePill: React.FC = () => {
  const { styles, cx } = useStyles();
  const [wallet, setWallet] = useState<API.WalletSummaryVO | null>(null);

  useEffect(() => {
    const unsub = subscribeWallet(setWallet);
    void refreshWallet();
    return unsub;
  }, []);

  const balance = wallet?.balance ?? 0;
  const warn = !!wallet?.lowBalance || !!wallet?.suspended || balance <= 0;

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={styles.pill}
        onClick={() => history.push('/fee-center/balance-recharge')}
        title="余额与充值"
      >
        <WalletOutlined className={styles.icon} />
        <span className={styles.label}>余额</span>
        <b className={cx(styles.amount, warn && styles.amountWarn)}>
          {fmtMoney(balance)}
        </b>
        <span className={styles.divider} />
        <span className={styles.recharge}>充值</span>
      </button>
    </div>
  );
};

export default BalancePill;
